exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links-preview[data-v-11e154e4] {\n  display: flex;\n  justify-content: flex-end;\n  max-width: 360px;\n  overflow: hidden;\n  position: relative;\n}\n.links-preview--vertical[data-v-11e154e4] {\n  flex-direction: column;\n}\n.links-preview--vertical .link-slide[data-v-11e154e4] {\n  margin-bottom: 4px;\n}\n.links-preview--vertical .link-slide[data-v-11e154e4]:last-child {\n    margin-bottom: 0;\n}\n", ""]);

// exports
